"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConditionalHelper_1 = require("../helpers/ConditionalHelper");

var Query_1 = require("./Query");

var BaseQuery_1 = require("./BaseQuery");

exports.MAX_CALL_STACK_LEVEL = 50;

var BaseEntityQuery =
/** @class */
function (_super) {
  __extends(BaseEntityQuery, _super);

  function BaseEntityQuery(queryOptions, translationHelper) {
    return _super.call(this, queryOptions, translationHelper) || this;
  }

  BaseEntityQuery.prototype.getSubCollection = function (executionOptions) {
    var queryOptionsType = this.queryOptions.queryOptionsType;
    var entity = this.getEntity(executionOptions);

    if (entity && entity[queryOptionsType]) {
      return entity[queryOptionsType];
    }

    return [];
  };

  BaseEntityQuery.prototype.getEntity = function (executionOptions) {
    var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({
      conditions: []
    }, this.translationHelper);
    var context = Query_1.Query.getContext(executionOptions, this.queryOptions);

    if (context) {
      var entityByType = context.entityByType;
      var _a = this.options,
          entityType = _a.entityType,
          entityConditional = _a.entityConditional;
      var entity = entityByType && entityType && entityByType[entityType];

      if (entity && (!entityConditional || conditionalHelper.matches(entity, entityConditional, executionOptions))) {
        return entity;
      }
    }

    return;
  };

  BaseEntityQuery.prototype.getEntities = function (executionOptions) {
    var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({
      conditions: []
    }, this.translationHelper);
    var context = Query_1.Query.getContext(executionOptions, this.queryOptions);

    if (context) {
      var entities = context.entities;
      var queryId = this.queryOptions.queryId;
      var entityConditional_1 = this.options.entityConditional;
      var entitiesContext = entities && queryId && entities[queryId];

      if (entitiesContext) {
        return entitiesContext.values.filter(function (entity) {
          return !entityConditional_1 || conditionalHelper.matches(entity, entityConditional_1, executionOptions);
        });
      }
    }

    return;
  };

  return BaseEntityQuery;
}(BaseQuery_1.BaseQuery);

exports.BaseEntityQuery = BaseEntityQuery;